import { Link } from "react-router-dom";
import { platforms, siteMeta } from "../../mocks/gossip";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-8 pt-14 pb-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-flashlight-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-bold text-xl tracking-tight">明星爆料</span>
            </Link>
            <p className="text-sm leading-relaxed text-background-200/80 max-w-md">{siteMeta.desc}</p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#!" onClick={(e) => e.preventDefault()} className="w-9 h-9 rounded-full bg-background-800 hover:bg-primary-600 flex items-center justify-center text-background-100 cursor-pointer transition" aria-label="微信">
                <i className="ri-wechat-line" aria-hidden="true"></i>
              </a>
              <a href="#!" onClick={(e) => e.preventDefault()} className="w-9 h-9 rounded-full bg-background-800 hover:bg-primary-600 flex items-center justify-center text-background-100 cursor-pointer transition" aria-label="微博">
                <i className="ri-weibo-line" aria-hidden="true"></i>
              </a>
              <a href="#!" onClick={(e) => e.preventDefault()} className="w-9 h-9 rounded-full bg-background-800 hover:bg-primary-600 flex items-center justify-center text-background-100 cursor-pointer transition" aria-label="小红书">
                <i className="ri-instagram-line" aria-hidden="true"></i>
              </a>
              <a href="#!" onClick={(e) => e.preventDefault()} className="w-9 h-9 rounded-full bg-background-800 hover:bg-primary-600 flex items-center justify-center text-background-100 cursor-pointer transition" aria-label="抖音">
                <i className="ri-music-2-fill" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading font-bold text-background-50 mb-4">平台频道</h4>
            <ul className="space-y-2.5">
              {platforms.map((p) => (
                <li key={p.slug}>
                  <Link to={`/channel/${p.slug}`} className="text-sm text-background-200/80 hover:text-accent-400 transition whitespace-nowrap">
                    {p.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading font-bold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-200/80 hover:text-accent-400 transition whitespace-nowrap">网站首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-200/80 hover:text-accent-400 transition whitespace-nowrap">关于我们</Link></li>
              <li><Link to="/#rank" className="text-sm text-background-200/80 hover:text-accent-400 transition whitespace-nowrap">全网热搜</Link></li>
              <li><Link to="/#feed" className="text-sm text-background-200/80 hover:text-accent-400 transition whitespace-nowrap">最新爆料</Link></li>
              <li><Link to="/about#contact" className="text-sm text-background-200/80 hover:text-accent-400 transition whitespace-nowrap">联系我们</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading font-bold text-background-50 mb-4">关注追更</h4>
            <p className="text-sm text-background-200/70 mb-4 leading-relaxed">第一时间获取新瓜进展，不错过任何一个后续。</p>
            <a href={`mailto:${siteMeta.email}`} className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 text-background-50 px-4 py-2 text-sm font-medium hover:bg-primary-400 whitespace-nowrap">
              <i className="ri-mail-line" aria-hidden="true"></i> 订阅提醒
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-200/60">© {year} {siteMeta.name} · 演示内容均为虚构，如有雷同纯属巧合。仅供娱乐，请理性看待网传信息。</p>
          <p className="text-xs text-background-200/60">微博 · 豆瓣 · 知乎 · 公众号 · 天涯 · 贴吧</p>
        </div>
      </div>
    </footer>
  );
}